// src/components/partners/tabs/PartnersTabShadcn.jsx
import React, { useState } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

// shadcn components
import { Alert, AlertDescription } from '../../ui/alert';
import { Button } from '../../ui/button';

// Import the shadcn list view
import PartnersListViewShadcn from '../../ui/lists/PartnersListView/PartnersListViewShadcn';

import { cn } from '../../../utils/cn';

const PartnersTabShadcn = ({
  connectedPartners = [],
  networkStats = {},
  loading = false,
  isConnected = true,
  onRefresh,
  className = ''
}) => {
  const [actionSuccess, setActionSuccess] = useState('');
  const [actionError, setActionError] = useState('');

  // Handle partner actions
  const handleMessage = (partnerId, partnerName) => {
    console.log('💬 Send message to partner:', partnerId, partnerName);
    // TODO: Implement messaging functionality
    setActionSuccess(`Message feature coming soon for ${partnerName}!`);
    setTimeout(() => setActionSuccess(''), 3000);
  };

  const handleViewDetails = (partnerId) => {
    console.log('👁️ View partner details:', partnerId);
    // TODO: Implement partner details view
    setActionSuccess('Partner details view coming soon!');
    setTimeout(() => setActionSuccess(''), 3000);
  };

  const handleDisconnect = (partnerId, partnerName) => {
    if (window.confirm(`Are you sure you want to disconnect from ${partnerName}? This action cannot be undone.`)) {
      console.log('🔌 Disconnect from partner:', partnerId, partnerName);
      // TODO: Implement disconnect functionality
      setActionSuccess(`Disconnected from ${partnerName}`);
      setTimeout(() => setActionSuccess(''), 3000);
    }
  };

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const clearMessages = () => {
    setActionSuccess('');
    setActionError('');
  };

  return (
    <div className={className}>
      {/* Connection Status Warning */}
      {!isConnected && (
        <Alert className="mb-6">
          <WifiOff className="h-4 w-4" />
          <AlertDescription className="flex items-center justify-between">
            <div>
              <p className="font-medium">You're currently offline</p>
              <p className="text-sm">Partner data may not be up to date. Reconnect to see latest changes.</p>
            </div>
            <Button variant="outline" size="sm" onClick={handleRefresh}>
              <RefreshCw className="w-4 h-4" />
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {/* Success Messages */}
      {actionSuccess && (
        <Alert className="mb-6 bg-emerald-500/20 text-emerald-300 border-emerald-500/30">
          <AlertDescription className="flex items-center justify-between">
            <span>{actionSuccess}</span>
            <Button variant="ghost" size="sm" onClick={clearMessages}>
              Dismiss
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {/* Error Messages */}
      {actionError && (
        <Alert variant="destructive" className="mb-6">
          <AlertDescription className="flex items-center justify-between">
            <span>{actionError}</span>
            <Button variant="ghost" size="sm" onClick={clearMessages}>
              Dismiss
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {/* Partners List */}
      <PartnersListViewShadcn
        partners={connectedPartners}
        stats={networkStats}
        loading={loading}
        onMessage={handleMessage}
        onViewDetails={handleViewDetails}
        onDisconnect={handleDisconnect}
      />
    </div>
  );
};

export default PartnersTabShadcn;